import React from "react";
import { BsCheckCircle, BsCircle } from "react-icons/bs";
import "../../../style/buttons.scss";
import "../../../style/block.scss";
import "./style/style.scss";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";
import EAButton from "../shared/Buttons/EAButton";
interface IProps {
  invoiceType: "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice";
  setInvoiceType: (value: "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice") => void;
}

const InvoiceButtons: React.FC<IProps> = ({ invoiceType, setInvoiceType }: IProps) => {
  const { t } = useTranslation();
  const facilityIds = useFacility();

  return (
    <React.Fragment>
      <div className="InvoiceButtons">
        <EAButton
          title={t("bez_faktury")}
          fullWidth
          onClick={() => setInvoiceType("noInvoice")}
          startIcon={invoiceType === "noInvoice" ? <BsCheckCircle /> : <BsCircle />}
          variant={invoiceType === "noInvoice" ? "filled" : "outlined"}
        />
        <EAButton
          title={t("faktura_na_osobe")}
          fullWidth
          onClick={() => setInvoiceType("customerInvoice")}
          startIcon={invoiceType === "customerInvoice" ? <BsCheckCircle /> : <BsCircle />}
          variant={invoiceType === "customerInvoice" ? "filled" : "outlined"}
        />
        <EAButton
          title={t("faktura_na_firme")}
          fullWidth
          onClick={() => setInvoiceType("companyInvoice")}
          startIcon={invoiceType === "companyInvoice" ? <BsCheckCircle /> : <BsCircle />}
          variant={invoiceType === "companyInvoice" ? "filled" : "outlined"}
        />

        {facilityIds === "1220" && (
          <EAButton
            title={t("faktura_na_nabywce_odbiorce")}
            fullWidth
            onClick={() => setInvoiceType("recipientAndPurchaserInvoice")}
            startIcon={invoiceType === "recipientAndPurchaserInvoice" ? <BsCheckCircle /> : <BsCircle />}
            variant={invoiceType === "recipientAndPurchaserInvoice" ? "filled" : "outlined"}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default InvoiceButtons;
